export const LocalStorageKey = {
  theme: 'Florence/Theme',
  sessionId: 'Florence/Session',
  showLogs: 'Florence/ShowLogs',
  localAccountId: 'Florence/LocalAccount',
};
